import { URLS } from '../../../constants';
import apiClient from '../../client';

export const DomainsByUserTypeApi = {
  getDomainByType: ({
    providerId,
    clientId,
    childPayerId,
  }: {
    providerId: string;
    clientId: string;
    childPayerId: any;
  }) =>
    apiClient.post(URLS.getDomainsByUserType, {
      data: {
        providerId,
        clientId,
        childPayerId,
      },
    }),
};

export const IntervenstionDomainsByUserTypeApi = {
  getDomainByType: ({
    organizationServiceId,
    clientId,
  }: {
    clientId: string;
    organizationServiceId: any;
  }) =>
    apiClient.post(URLS.getIntervenstionDomainsByUserType, {
      data: {
        clientId,
        organizationServiceId,
      },
    }),
};
